var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6557 4.89797H10.4953C10.2774 4.89797 10.1009 5.07454 10.1009 5.29234C10.1009 5.51015 10.2774 5.68672 10.4953 5.68672H13.6557C13.8735 5.68672 14.05 5.51015 14.05 5.29234C14.05 5.07454 13.8735 4.89797 13.6557 4.89797Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0484 5.30263V2.30838C14.0484 2.09319 13.8739 1.91875 13.6587 1.91875C13.4435 1.91875 13.2691 2.09319 13.2691 2.30838V5.30263C13.2691 5.51781 13.4435 5.69226 13.6587 5.69226C13.8739 5.69226 14.0484 5.51781 14.0484 5.30263Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26587 1.87952C8.88753 1.28644 11.4889 2.58068 12.6962 4.86264C12.7829 5.02643 12.9683 5.11825 13.1514 5.07493C13.3918 5.01806 13.5254 4.75469 13.4097 4.53142C12.0558 1.91927 9.09244 0.431372 6.10756 1.11625C3.12533 1.80052 1.07841 4.42184 0.955826 7.37242C0.94526 7.62673 1.18412 7.80848 1.42734 7.75093C1.60572 7.70872 1.72879 7.5499 1.73708 7.36952C1.85565 4.79111 3.66275 2.49554 6.26587 1.87952Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43201 9.8228L4.59236 9.8228C4.81019 9.8228 4.98677 9.64621 4.98677 9.42839C4.98677 9.21057 4.81019 9.03398 4.59236 9.03398L1.43201 9.03398C1.21418 9.03398 1.0376 9.21057 1.0376 9.42839C1.0376 9.64621 1.21418 9.8228 1.43201 9.8228Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03904 9.42002L1.03904 12.4143C1.03904 12.6295 1.21349 12.8039 1.42868 12.8039C1.64387 12.8039 1.81831 12.6295 1.81831 12.4143L1.81831 9.42002C1.81831 9.20483 1.64387 9.03038 1.42868 9.03038C1.21349 9.03038 1.03904 9.20483 1.03904 9.42002Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73385 12.8485C6.1122 13.4415 3.51087 12.1473 2.30351 9.86535C2.21685 9.70156 2.03138 9.60975 1.84829 9.65306C1.60795 9.70993 1.47431 9.9733 1.59003 10.1966C2.94391 12.8087 5.90729 14.2966 8.89216 13.6117C11.8744 12.9275 13.9213 10.3061 14.0439 7.3556C14.0545 7.10128 13.8156 6.91954 13.5724 6.97708C13.394 7.01929 13.2709 7.17811 13.2626 7.35849C13.1441 9.93688 11.337 12.2324 8.73385 12.8485Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.93e48fd389c9dae27f3949968577f81e.svg";
export { ForwardRef as ReactComponent };